module.exports = __webpack_public_path__ + "static/media/game_over.045b6569.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/game_over.ogg
// module id = 291
// module chunks = 0